import { render, staticRenderFns } from "./FileInfoModal.vue?vue&type=template&id=77c1d364&scoped=true"
import script from "./FileInfoModal.vue?vue&type=script&lang=js"
export * from "./FileInfoModal.vue?vue&type=script&lang=js"
import style0 from "./FileInfoModal.vue?vue&type=style&index=0&id=77c1d364&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c1d364",
  null
  
)

export default component.exports